import { Component, Input } from '@angular/core';
import { PRODUCT_PRICE_CONST } from '../../../asset/constants/product-price.constant';

@Component({
  selector: 'app-unit-price',
  templateUrl: './unit-price.component.html',
  styleUrls: ['./unit-price.component.scss']
})
export class UnitPriceComponent {
  public PRODUCT_PRICE_CONST = PRODUCT_PRICE_CONST;
  @Input() product;
  @Input() quantity;
}
